export default "__VITE_ASSET__DjBdBbji__"